import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8bd7fbb4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8bd7fbb4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd7fbb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bd7fbb4')) {
      api.createRecord('8bd7fbb4', component.options)
    } else {
      api.reload('8bd7fbb4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8bd7fbb4&scoped=true", function () {
      api.rerender('8bd7fbb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/didi/order/index.vue"
export default component.exports